import { Typography, useTheme } from '@mui/material'
import React from 'react'

const CountBadge = ( { value = 0 } ) => {

    const { palette } = useTheme()

    return (
        <Typography
            component="span"
            color={palette.primary.contrastText}
            sx={{
                minWidth: "22px",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "fit-content",
                borderRadius: "5px",
                bgcolor: palette.primary.light + "66",
                padding: "2px 5px"
            }}>
            {value}
        </Typography>
    )
}

export default CountBadge
